// extracted by mini-css-extract-plugin
export default {"text":"bgs_text__AMDln","terrible":"bgs_terrible__SJQ2E","bad":"bgs_bad__PiGkc","ok":"bgs_ok__McDyn","nice":"bgs_nice__iV+OF","good":"bgs_good__tvwLa"};